import React, { useRef, useState } from 'react';
import './Food.css';

import star from '../../../assets/Star.png'; // Assuming the star icon is stored in a file named 'star.png'
import Food1 from '../../../assets/OMFLogo.png';
import FoodMenuDetailsModal from './FoodMenuDetailsModal';
import OrderPopop from '../../../Components/OrderPopop';
import axiosVendorInstance from '../../../axiosVendorInstance';
import { IoPlayOutline } from 'react-icons/io5';
import { HashLoader } from 'react-spinners';
import Loader from '../../../Components/Loader/Loader';
import locationIcon from '../../../assets/locationImg.svg';
import { Helmet } from 'react-helmet';
import { SEO } from '../../../Utils/Constant';

function Food({ searchTerm, results, lastElementRef, loading }) {
    const validResults = results || [];
    const [selectedFood, setSelectedFood] = useState(null);
    const [open, setOpen] = useState(false);
    const [openPopup, setOpenPopup] = useState(false);
    const [vendorId, setVendorId] = useState(null);
    const [restaurantName, setRestaurantName] = useState(null);
    const [vendorRating, setVendorRating] = useState(null);
    const [vendorAddress, setVendorAddress] = useState(null);
    const [vendorDistance, setVendorDistance] = useState(null);
    const videoRefs = useRef({});
    const [playingIndex, setPlayingIndex] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleClose = () => {
        setOpen(false);
        setSelectedFood(null);
        setRestaurantName(null);
        setVendorRating(null);
        setVendorAddress(null);
        setVendorId(null);
        setVendorDistance(null);
    };

    const handlePlay = (e, index) => {
        e.stopPropagation();
    
        Object.entries(videoRefs.current).forEach(([key, video]) => {
            if (parseInt(key) !== index && video && !video.paused) {
                video.pause();
            }
        });
    
        const currentVideo = videoRefs.current[index];
        if (currentVideo) {
            currentVideo.play();
            setPlayingIndex(index);
        }
    };

    const fetchFoodDetails = async (itemId,vendorDistance) => {
        try {
            setIsLoading(true);
            const response = await axiosVendorInstance.get(
                `/vendors/menuitems/particularitem/${itemId}`,{skipAuth: true}
            );
            setIsLoading(false);
            const data = response?.data?.menuItem;
            setSelectedFood(data);
            setRestaurantName(data?.VendorName);
            setVendorId(data?.VendorID);
            setVendorRating(data?.VendorAvgRating);
            setVendorAddress(data?.VendorAddress);
            setVendorDistance(vendorDistance);
            setOpen(true);
        } catch (error) {
            setIsLoading(false);
            console.error('Error fetching offer details:', error);
        }
    };

    const filteredFoods = validResults.filter((foods) =>
        foods?.Menu_Item_Name?.toLowerCase().includes(searchTerm.trim().toLowerCase())
    );

    const handleOrderClick = () => {
        setOpenPopup(!openPopup);
    };

    return (
        <div className='food-container-fake'>
            <Helmet>
                <title>{SEO.FOOD_LIST_PAGE.TITLE}</title>
                <meta name="description" content={SEO.FOOD_LIST_PAGE.DESCRIPTION} />
                <meta name="keywords" content={SEO.FOOD_LIST_PAGE.KEYWORDS} />
                <meta name="robots" content="index, follow" />
                                    
                <meta property="og:title" content={SEO.FOOD_LIST_PAGE.TITLE} />
                <meta property="og:description" content={SEO.FOOD_LIST_PAGE.DESCRIPTION} />
                <meta property="og:type" content={SEO.FOOD_LIST_PAGE.OG.TYPE} />
                <meta property="og:site_name" content={SEO.FOOD_LIST_PAGE.OG.SITE_NAME} />
                <meta property="og:image" content='https://omyfood.io/OMF_logo_bg.png' />
                                    
                <meta name="twitter:image" content='https://omyfood.io/OMF_logo_bg.png' />
                <meta name="twitter:title" content={SEO.FOOD_LIST_PAGE.TWITTER.TITLE} />
                <meta name="twitter:description" content={SEO.FOOD_LIST_PAGE.TWITTER.DESCRIPTION} />
                <meta
                    name="twitter:card"
                    content='summary_large_image'
                />
            </Helmet>
            {isLoading && <Loader />}
            <div className='Food-Nearby-restaurants-cards-container'>
                <div className="justify-content-center-2">
                    {filteredFoods?.length > 0 && (
                        filteredFoods?.map((food, index) => {
                            const isLastElement = index === filteredFoods?.length - 1;
                            return (
                                <div
                                    key={index}
                                    className='Food-search-restaurants-card'
                                    ref={isLastElement ? lastElementRef : null}
                                    onClick={() => fetchFoodDetails(food?.Menu_Item_ID,food?.Distance_in_Miles)}
                                >   
                                    <div className="food-media-wrapper">
                                        {food?.Menu_Item_Avatar?.match(/\.(mp4|webm|ogg)$/i) ? (
                                            <div className="video-container1">
                                                <video
                                                    src={food?.Menu_Item_Avatar}
                                                    muted
                                                    playsInline
                                                    // eslint-disable-next-line react/no-unknown-property
                                                    webkit-playsinline='true'
                                                    preload="metadata"
                                                    className="food-video"
                                                    ref={(el) => videoRefs.current[index] = el}
                                                    onClick={() => {
                                                        const video = videoRefs.current[index];
                                                        if (video && !video.paused) {
                                                            video.pause();
                                                            setPlayingIndex(null);
                                                        }
                                                    }}
                                                    onEnded={() => setPlayingIndex(null)}
                                                    onError={(e) => {
                                                        e.target.poster = Food1;
                                                    }}
                                                />
                                                {playingIndex !== index && (
                                                    <button onClick={(e) => handlePlay(e, index)} className='play-btn'>
                                                        <IoPlayOutline color='white' fontSize={34} />
                                                    </button>
                                                )}

                                            </div>
                                        ) : (
                                            <img
                                                className='Food-search-restaurants-image'
                                                src={food?.Menu_Item_Avatar || Food1}
                                                alt='Food img'
                                                onError={(e) => {
                                                    e.target.src = Food1;
                                                }}
                                            />
                                        )}
                                    </div>

                                    <div className='Food-search-restaurants-content'>
                                        <span className='Food-search-restaurants-text'>
                                            {food?.Menu_Item_Name}
                                        </span>
                                        <div className='Food-search-restaurant-footer'>
                                            <div className="location-miles-container">
                                                <img 
                                                    src={locationIcon} 
                                                    alt="location" 
                                                    style={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }}
                                                />
                                                <span className='Food-search-restaurant-dist'>
                                                    {food?.Distance_in_Miles?.toFixed(1)} miles
                                                </span>
                                            </div>
                                            <div className='Food-dist-layout'>
                                                <img
                                                    className='Food-search-rest-star-icon-image'
                                                    src={star}
                                                    alt='search-rest-star icon'
                                                />
                                                <span className='Food-search-rest-reviews'>
                                                    {(food?.Item_AvgRating ?? 0)?.toFixed(1)} ratings
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    ) }
                </div>
                {filteredFoods.length === 0 && (
                    <h5 className='no-data-found'>No Item Found</h5>
                )}
            </div>
            {loading && (
                <div className='search-onload-loader'>
                    <HashLoader
                        color="#E13535"
                        loading={true}
                        size={50}
                    />
                </div>
            )}

            {selectedFood && (
                <FoodMenuDetailsModal
                    open={open}
                    handleClose={handleClose}
                    food={selectedFood}
                    handleOrderClick={handleOrderClick}
                    rating={vendorRating}
                    vendorId={vendorId}
                    orderBtn={true}
                    vendorDistance={vendorDistance}
                />
            )}
            <div>
                {openPopup && 
                    <OrderPopop
                        restaurantName={restaurantName}
                        handleClose={()=> {
                            setTimeout(() => {
                                setOpenPopup(!openPopup);
                            }, 500);
                        }}
                        vendorID={vendorId}
                        rating={vendorRating}
                        vendorAddress={vendorAddress}
                        vendorDistance={vendorDistance}
                    />
                }
            </div>
        </div>
    );
}

export default Food;
